import { render, staticRenderFns } from "./IpadIcon.vue?vue&type=template&id=3f7bf1ab&"
import script from "./IpadIcon.vue?vue&type=script&lang=js&"
export * from "./IpadIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports